export const NullComponent = {
  name: 'NullComponent',
  render: () => null
}

/**
 * This function resolves the actual component when app is in the client mode. Otherwise it resolves to NullComponent.
 *
 * It must be used in cases when we don't want to render a component in SSR mode.
 *
 * @param factory - must be a function that returns a promise with a valid component instance.
 */
export const clientOnlyComponent = (factory) => {
  return function () {
    return process.client ? factory() : Promise.resolve(NullComponent)
  }
}
